// extracted by mini-css-extract-plugin
export default {"tabnavigator":"tabnavigator_ab650cb5dbcd72cddefe","header":"header_b5d1ead945b9750d9014","container":"container_f0f79f89c3afe59bb21d","indicator":"indicator_df78a0fb79f7e6a62ea6"};